import React, { useMemo } from 'react';
import {
	Paper,
	FormLabel,
	Divider,
	RadioGroup,
	FormControlLabel,
	Radio,
	Tooltip,
} from '@mui/material';
import { SmartSwitch } from '~/FielderElements/SmartTaskTable/SmartStyles';
import Grid from '@mui/material/Grid2';
import { AccountTree } from '@mui/icons-material';
import { FielderHard } from '@core/theme/baseTheme';

const SetupFunctionalityFilter = (
	{
		lan,
		searchFunctionalities,
		selectedFunctionality,
		onFunctionalityChange,
		enabled,
		onToggle,
	}) => {
	const options = useMemo(() => ([
		//{ value: searchFunctionalities.ALL, title: lan.all, description: lan.searchAllFunctionalities }, return to activate later
		{ value: searchFunctionalities.FORMS, title: lan.forms, description: lan.searchFormsOnly },
		//{ value: searchFunctionalities.ASSETS, title: lan.assets, description: lan.searchAssetsOnly }, return to activate later
		//{ value: searchFunctionalities.INVENTORIES, title: lan.inventories, description: lan.searchInventoriesOnly }, return to activate later
		{ value: searchFunctionalities.NONE, title: lan.none, description: lan.searchNoneFunctionalities },
	]), [
		lan.all, lan.searchAllFunctionalities, lan.forms, lan.searchFormsOnly, lan.assets, lan.searchAssetsOnly,
		lan.inventories, lan.searchInventoriesOnly, lan.none, lan.searchNoneFunctionalities,
		searchFunctionalities.ALL, searchFunctionalities.FORMS, searchFunctionalities.ASSETS,
		searchFunctionalities.INVENTORIES, searchFunctionalities.NONE,
	]);
	const handleToggle = (event) => {
		onToggle?.(event.target.checked);
	};
	const handleChange = (event) => {
		onFunctionalityChange?.(event.target.value);
	};
	const tooltipLabel = enabled ? lan.hideFunctionalityOptions : lan.showFunctionalityOptions;
	return (
		<Paper variant="outlined" sx={{ p: 2, height: '100%' }}>
			<Grid container direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: enabled ? 1 : 0 }}>
				<Grid size={12}>
					<FormLabel>{lan.functionalities || 'Selection'}</FormLabel>
				</Grid>
				<Grid size={12}>
					<Tooltip arrow title={tooltipLabel} placement="right">
						<FormControlLabel
							control={<SmartSwitch id='filter-by-functionalies-switch' checked={enabled} onChange={handleToggle} />}
							label={<AccountTree fontSize={"small"} sx={{ color: `${enabled? FielderHard: ''}` }} />}
							labelPlacement={"start"}
							sx={{ marginTop: '9px', }}
						>
						</FormControlLabel>
					</Tooltip>
				</Grid>
			</Grid>
			{enabled && (
				<>
					<Divider sx={{ mb: 1 }} />
					<RadioGroup
						value={String(selectedFunctionality)}
						name="functionality-radio"
						onChange={handleChange}
					>
						{options.map((option) => (
							<Tooltip
								key={`tooltip-${String(option.value)}`}
								arrow
								placement="right"
								title={option.description}
							>
								<FormControlLabel
									key={`radio-${String(option.value)}`}
									value={String(option.value)}
									control={<Radio size="small" />}
									label={option.title}
									sx={{ my: 0.25 }}
								/>
							</Tooltip>
						))}
					</RadioGroup>
				</>
			)}
		</Paper>
	);
};

export default SetupFunctionalityFilter;
